import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';

interface DataToolbarProps {
  onAddFromSchedule: () => void;
  onAddCustom: () => void;
  onDeclineAll: () => void;
  disabled?: boolean;
}

export const DataToolbar = ({ onAddFromSchedule, onAddCustom, onDeclineAll, disabled = false }: DataToolbarProps) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const confirmDeclineAll = () => {
    setConfirmOpen(false);
    onDeclineAll();
  };

  return (
    <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
      <Button variant="contained" disabled={disabled} onClick={onAddFromSchedule}>
        Add punches from schedule
      </Button>
      <Button variant="outlined" disabled={disabled} onClick={onAddCustom}>
        Add custom punches
      </Button>
      <Button variant="outlined" color="error" disabled={disabled} onClick={() => setConfirmOpen(true)}>
        Decline all punches in range
      </Button>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Decline all punches in range?</DialogTitle>
        <DialogContent>
          <DialogContentText>This declines every punch currently loaded in the range, not just punches created by this tool. There is no way to tell them apart. This cannot be undone from here.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button color="error" variant="contained" onClick={confirmDeclineAll}>
            Decline
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
};

export default DataToolbar;
